/**
 * 検索用の正規化（02 9.1 D-101）。normalized_customer_name と検索語 q の両方をこの関数でそろえてから begins_with で比べる。
 * NFKC 正規化 → 英字を小文字 → 空白（全角を含む）を除く → 先頭・末尾の法人格の表記を除く → 記号（・，．、。-）を除く。
 */

/** 法人格の表記（長いものから順に比べる。括弧つきの略記は NFKC 後の形も含める） */
const LEGAL_ENTITY_MARKS = [
  '特定非営利活動法人',
  '一般社団法人',
  '一般財団法人',
  '公益社団法人',
  '公益財団法人',
  '株式会社',
  '有限会社',
  '合同会社',
  '合資会社',
  '合名会社',
  '（株）',
  '(株)',
  '㈱',
  '（有）',
  '(有)',
  '㈲',
].map((mark) => mark.normalize('NFKC'));

const WHITESPACE_PATTERN = /[\s\u3000]+/g;
const SYMBOL_PATTERN = /[・，．、。\-,.]/g;

function stripLegalEntityMarks(value: string): string {
  let result = value;
  let is_changed = true;
  while (is_changed) {
    is_changed = false;
    for (const mark of LEGAL_ENTITY_MARKS) {
      if (result.startsWith(mark)) {
        result = result.slice(mark.length);
        is_changed = true;
      }
      if (result.endsWith(mark)) {
        result = result.slice(0, result.length - mark.length);
        is_changed = true;
      }
    }
  }
  return result;
}

/** 顧客名・検索語の正規化（D-101）。空・undefined は空文字を返す（エラーにしない） */
export function normalizeCustomerName(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  const unified = value.normalize('NFKC').toLowerCase().replace(WHITESPACE_PATTERN, '');
  const normalized = stripLegalEntityMarks(unified).replace(SYMBOL_PATTERN, '');
  // 法人格・記号だけの名前（例「株式会社」）は空になる。GSI のソートキーに空文字は入れられないため、空白を除いた形を使う
  return normalized === '' ? unified : normalized;
}

/** 部分一致の比較用（担当者の姓・名・メール等：NFKC＋小文字＋前後の空白を除く） */
export function normalizeForContains(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  return value.normalize('NFKC').toLowerCase().trim();
}
